/**
 * @generated SignedSource<<90b9229b96fe7a44506152a3799f0a07>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClassExitSlipsFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  dueOnFrom?: any | null | undefined;
  dueOnTo?: any | null | undefined;
  includeCanceled?: boolean | null | undefined;
  userIds?: ReadonlyArray<string> | null | undefined;
};
export type LearnosityExitSlipSessionsFilterInput = {
  classExitSlipIds?: ReadonlyArray<string> | null | undefined;
  classIds?: ReadonlyArray<string> | null | undefined;
  curriculumLessonIds?: ReadonlyArray<string> | null | undefined;
  sessionCompletedOn?: any | null | undefined;
  sessionStartedOn?: any | null | undefined;
  userIds?: ReadonlyArray<string> | null | undefined;
};
export type DashboardGetStudentExitSlipQuery$variables = {
  filter: ClassExitSlipsFilterInput;
  learnosityExitSlipSessionsFilter?: LearnosityExitSlipSessionsFilterInput | null | undefined;
};
export type DashboardGetStudentExitSlipQuery$data = {
  readonly classExitSlips: ReadonlyArray<{
    readonly curriculumLesson: {
      readonly hasExitSlip: boolean;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly number: string | null | undefined;
      readonly skills: ReadonlyArray<{
        readonly code: string | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly dueOn: any;
    readonly id: string;
    readonly learnosityExitSlipSessions: ReadonlyArray<{
      readonly activityId: string | null | undefined;
      readonly id: string;
      readonly isComplete: boolean;
      readonly publicUserId: string | null | undefined;
      readonly user: {
        readonly firstName: string | null | undefined;
        readonly id: string;
        readonly lastName: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  }>;
};
export type DashboardGetStudentExitSlipQuery = {
  response: DashboardGetStudentExitSlipQuery$data;
  variables: DashboardGetStudentExitSlipQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "learnosityExitSlipSessionsFilter"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "ClassExitSlipNode",
    "kind": "LinkedField",
    "name": "classExitSlips",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dueOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CurriculumLessonNode",
        "kind": "LinkedField",
        "name": "curriculumLesson",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillNode",
            "kind": "LinkedField",
            "name": "skills",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "number",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasExitSlip",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "learnosityExitSlipSessionsFilter",
            "variableName": "learnosityExitSlipSessionsFilter"
          }
        ],
        "concreteType": "LearnosityExitSlipSessionNode",
        "kind": "LinkedField",
        "name": "learnosityExitSlipSessions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activityId",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isComplete",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicUserId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardGetStudentExitSlipQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardGetStudentExitSlipQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "a4f50db4ac419ef6b15e267f210de442",
    "id": null,
    "metadata": {},
    "name": "DashboardGetStudentExitSlipQuery",
    "operationKind": "query",
    "text": "query DashboardGetStudentExitSlipQuery(\n  $filter: ClassExitSlipsFilterInput!\n  $learnosityExitSlipSessionsFilter: LearnosityExitSlipSessionsFilterInput\n) {\n  classExitSlips(filter: $filter) {\n    id\n    dueOn\n    curriculumLesson {\n      skills {\n        id\n        code\n        name\n      }\n      id\n      number\n      name\n      hasExitSlip\n    }\n    learnosityExitSlipSessions(learnosityExitSlipSessionsFilter: $learnosityExitSlipSessionsFilter) {\n      activityId\n      id\n      isComplete\n      publicUserId\n      user {\n        id\n        firstName\n        lastName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b102471bb4b24e423ade3db9cd4d2166";

export default node;
